import React, { useEffect, memo } from "react";
import { useInView } from 'react-intersection-observer';

const ScrollIntersectionObserver = (props) => {

    const { ref: scrollRef, inView: isInView } = useInView();

    useEffect(() => {
        if(props.isClass){
            const elements = document.getElementsByClassName(props.element)
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                setScrollElementClass(element)
            }
        } else{
            let element = document.getElementById(props.element)
            setScrollElementClass(element)
        }
    })

    const setScrollElementClass = (element) => {
        if(isInView) {
            element.classList.add('scrolledTo')
        }else {
            element.classList.remove('scrolledTo')
        }
    }

    return(<div ref={scrollRef}></div>)
}

export default memo(ScrollIntersectionObserver);